import { createAppAsyncThunk } from '../../@types/redux';
import generalActions from './actions';

export default class GeneralThunks {
    /**
     * Adds an error snackbar to the queue. Attempts to retrieve the error message from the API, falling back to the default
     * message if the API returns no such thing.
     * @param defaultMessage
     * @param ex
     */
    public static showErrorSnackbar = createAppAsyncThunk(
        'general/showErrorSnackbar',
        async (params : {
            defaultMessage : string;
            ex ?: any;
        }, ThunkApi) => {
            let errorMessage = params.defaultMessage;

            if (typeof(params.ex) === 'object') {
                if (params.ex.response) {
                    errorMessage = 'Error: ' + params.ex.response.data.Message;
                }

                if (params.ex.data) {
                    errorMessage = 'Error: ' + params.ex.data.Message;
                }
            }

            if (typeof(params.ex) === 'string') {
                errorMessage += params.ex;
            }

            ThunkApi.dispatch(generalActions.enqueueSnackbar({
                message: errorMessage,
                options: {
                    variant: 'error',
                },
            }));
        }
    )

    /**
     * Adds a success snackbar to the queue.
     * @param message
     */
    public static showSuccessSnackbar = createAppAsyncThunk(
        'general/showSuccessSnackbar',
        async (message : string, ThunkApi)=> {
            ThunkApi.dispatch(generalActions.enqueueSnackbar({
                message,
                options: {
                    variant: 'success',
                },
            }));
            
        }
    )

    /**
     * Adds a warning snackbar to the queue.
     * @param message
     */
    public static showWarningSnackbar = createAppAsyncThunk(
        'general/showWarningSnackbar',
        async (message : string, ThunkApi)=> {
            ThunkApi.dispatch(generalActions.enqueueSnackbar({
                message,
                options: {
                    variant: 'warning',
                },
            }));
            
        }
    )

    /**
     * Adds a info snackbar to the queue.
     * @param message
     */
        public static showInfoSnackBar = createAppAsyncThunk(
            'general/showInfoSnackBar',
            async (message : string, ThunkApi) => {    
                ThunkApi.dispatch(generalActions.enqueueSnackbar({
                    message,
                    options: {
                        variant: 'info',
                    },
                }));
                
            }
        )
}

